import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaBell, FaEnvelope, FaCog, FaUsers, FaUtensils } from "react-icons/fa";
import "../styles/Sidebar.css";
import { FaSignOutAlt } from 'react-icons/fa';

const Sidebar = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  const handleHomeClick = (e) => {
    // Only clear filters if we're already on the home page
    if (location.pathname === '/') {
      if (window.clearHomeFilters) {
        window.clearHomeFilters();
      }
    }
  };

  return (
    <div className="sidebar">
      <nav className="sidebar-menu">
        <ul>
          <li>
            <Link to="/" className={`sidebar-item ${isActive("/") ? "active" : ""}`} onClick={handleHomeClick}>
              <FaHome className="sidebar-icon" /> Home
            </Link>
          </li>
          <li>
            <Link to="/message" className={`sidebar-item ${isActive("/message") ? "active" : ""}`}>
              <FaEnvelope className="sidebar-icon" /> Messages
            </Link>
          </li>
          <li>
            <Link to="/restlist" className={`sidebar-item ${isActive("/restlist") ? "active" : ""}`}>
              <FaUtensils className="sidebar-icon" /> Restaurants
            </Link>
          </li>
        </ul>
      </nav>

      <nav className="sidebar-menu bottom-menu">
        <ul>
          <li>
            <Link to="/style-guide" className={`sidebar-item ${isActive("/style-guide") ? "active" : ""}`}>Style Guide</Link>
          </li>
          <li>
            <Link to="/about" className={`sidebar-item ${isActive("/about") ? "active" : ""}`}>About Us</Link>
          </li>
          {isLoggedIn && (
            <>
              <li>
                <Link to="/settings" className={`sidebar-item ${isActive("/settings") ? "active" : ""}`}>
                  <FaCog className="sidebar-icon" /> Settings
                </Link>
              </li>
              <li>
                <Link to="/logout" className={`sidebar-logout ${isActive("/logout") ? "active" : ""}`}>
                  <FaSignOutAlt className="sidebar-icon" /> Logout
                </Link>
              </li>
            </>
          )}
        </ul>
      </nav>
      <div className="sidebar-help"></div>
    </div>
  );
};

export default Sidebar;
